import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { ContentGuide } from '@/global/guides/ContentGuide/ContentGuide'
import { PerfilPermissao, permissoes } from '@/service/api'
import { PencilIcon, Trash2Icon, UserRoundPlusIcon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'

const columns: GridColDefPro<PerfilPermissao>[] = [
    {
        field: 'nome',
        headerName: 'Nome',
        flex: 1,
        minWidth: 200,
    },
    {
        field: 'read',
        headerName: 'Leitura',
        width: 120,
        type: 'number',
        valueGetter: ({ row }) =>
            row.ModuloPermissao.filter(a => a.read).length,
    },
    {
        field: 'create',
        headerName: 'Criação',
        width: 120,
        type: 'number',
        valueGetter: ({ row }) =>
            row.ModuloPermissao.filter(a => a.create).length,
    },
    {
        field: 'update',
        headerName: 'Atualização',
        width: 120,
        type: 'number',
        valueGetter: ({ row }) =>
            row.ModuloPermissao.filter(a => a.update).length,
    },
    {
        field: 'delete',
        headerName: 'Exclusão',
        width: 120,
        type: 'number',
        valueGetter: ({ row }) =>
            row.ModuloPermissao.filter(a => a.delete).length,
    },
    {
        ...optionsColumn,
        field: '__associar',
        renderCell: ({ id }) => (
            <IconButton href={`${id}/associar`} title="Associar usuários">
                <UserRoundPlusIcon />
            </IconButton>
        ),
    },
    {
        ...optionsColumn,
        field: '__editar',
        renderCell: ({ id }) => (
            <IconButton href={`${id}/editar`} title="Editar">
                <PencilIcon />
            </IconButton>
        ),
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: ({ id }) => (
            <IconButton href={`${id}/excluir`} title="Excluir">
                <Trash2Icon className="text-error" />
            </IconButton>
        ),
    },
]

export default function PermissoesUsuarios() {
    const { data = [], isLoading } = permissoes.useFetch()

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Permissões']} />
                <ContentGuide.DataGrid
                    rows={data}
                    columns={columns}
                    onAdd
                    loading={isLoading}
                    columnGroupingModel={[
                        {
                            groupId: 'Permissões',
                            children: ['read', 'create', 'update', 'delete'],
                            headerAlign: 'center',
                        },
                    ]}
                    headerHeight={35}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function usePermissoesOutletContext() {
    return useOutletContext<{ data: PerfilPermissao[] }>()
}
